import fetch from "auth/FetchInterceptor";
import {
  MASTERS_CONTRACT_ROLES,
  MASTERS_CONTRACT_TYPES,
  MASTERS_DOCUMENT_TYPES,
  MASTERS_GROUP,
  MASTERS_CONTRACT_TASK_TYPES,
  ORGANISATIONS,
  GET_DOCUMENTS,
  MASTER_ROLES,
  DELETE_ROLE,
  UPDATE_ROLE,
} from "constants/ApiConstant";

const MasterService = {};

MasterService.getGroups = function (params) {
  return fetch({
    url: MASTERS_GROUP,
    method: "get",
    params,
  });
};

MasterService.getContractTypes = function (params) {
  return fetch({
    url: MASTERS_CONTRACT_TYPES,
    method: "get",
    params,
  });
};

MasterService.getDocumentTypes = function (params) {
  return fetch({
    url: MASTERS_DOCUMENT_TYPES,
    method: "get",
    params,
  });
};

MasterService.getContractRoles = function (params) {
  return fetch({
    url: MASTERS_CONTRACT_ROLES,
    method: "get",
    params,
  });
};

MasterService.getContractTaskTypes = function (params) {
  return fetch({
    url: MASTERS_CONTRACT_TASK_TYPES,
    method: "get",
    params,
  });
};

MasterService.getOrganisations = function (params) {
  return fetch({
    url: ORGANISATIONS,
    method: "get",
    params,
  });
};

MasterService.getDocument = function (data, config) {
  return fetch({
    url: GET_DOCUMENTS,
    method: "post",
    data: data,
    ...config,
  });
};

MasterService.getRoles = function (params) {
  return fetch({
    url: MASTER_ROLES,
    method: "get",
    params,
  });
};

MasterService.addRoles = function (payload) {
  return fetch({
    url: MASTER_ROLES,
    method: "post",
    data: payload,
  });
};

MasterService.deleteRole = function (id) {
  return fetch({
    url: DELETE_ROLE(id),
    method: "delete",
  });
};

MasterService.updateRole = function (id, payload) {
  return fetch({
    url: UPDATE_ROLE(id),
    method: "patch",
    data: payload,
  });
};

export default MasterService;
